/**
 * Default theme used by the screen gallery.
 *
 * This is the raw theme shape (the same structure the backend used to serve as
 * `theme.json`): a `font` map consumed by `useTheme(font)` and a `colors` map
 * consumed by `generateColorsByView(colors)`.
 *
 * It is bundled (no network fetch) so the gallery is fully autonomous, and it
 * doubles as the seed value shown in the Control Dock JSON editor.
 */
export interface RawTheme {
  font: Record<string, unknown> & {
    fontfamily: string;
    fontcdn: string;
  };
  colors: Record<string, unknown> & {
    lightness?: string;
  };
}

export const defaultTheme: RawTheme = {
  font: {
    h1: { fontWeight: '400', min: '1.75rem', max: '2rem', lineHeight: '1' },
    highlight: {
      fontWeight: '700',
      min: '1.75rem',
      max: '2rem',
      lineHeight: '0.95',
    },
    h2: { fontWeight: '600', min: '1.25rem', max: '1.5rem', lineHeight: '1' },
    bodycopy: {
      fontWeight: '500',
      min: '1rem',
      max: '1.25rem',
      lineHeight: '1.25rem',
    },
    secondaryCta: {
      fontWeight: '500',
      min: '0.74rem',
      max: '1rem',
      lineHeight: '1',
    },
    footerText: {
      fontWeight: '500',
      min: '0.85rem',
      max: '0.85rem',
      lineHeight: '1',
    },
    mainButtonText: {
      fontWeight: '600',
      min: '1.15rem',
      max: '1.25rem',
      lineHeight: '2rem',
    },
    step: { fontWeight: '600', min: '0.5rem', max: '0.875rem', lineHeight: '1' },
    fontfamily: 'Manrope',
    fontcdn:
      'https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap',
  },
  colors: {
    primaryGradient: '#3D2BFF',
    secondaryGradient: '#7C3AED',
    secondaryColor: '#252525',
    whiteColor: '#FFFFFF',
    inactived: '#979797',
    errorColor: '#E81C1C',
    partnerHighlights: '#ffffff',
    gradientDeg: '116.74deg',
    primaryGradientPoint: '23.26%',
    secundaryGradientPoint: '111.43%',
    primaryMesh: 'linear-gradient(116.74deg, #3D2BFF 23.26%, #7C3AED 111.43%)',
    gradient: 'linear-gradient(116.74deg, #3D2BFF 23.26%, #7C3AED 111.43%)',
    lightness: 'dark',
  },
};
